import { useParams } from "react-router-dom";
import WalletDetailView from "@/features/wallets/wallet-detail";
import WalletMissing from "@/features/wallets/wallet-missing";
import { DataSourceBadge } from "@/components/data-display/data-source-badge";
import { useWalletDetail } from "@/hooks/use-wallet-detail";

export default function WalletDetailPage() {
  const { id } = useParams();
  const { detail, loading, error, source, refresh } = useWalletDetail(id!);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="spinner" aria-label="Loading wallet" />
      </div>
    );
  }

  if (error || !detail) {
    return <WalletMissing id={id!} />;
  }

  return (
    <div>
      <div className="mb-3 flex items-center gap-2">
        <DataSourceBadge source={source} />
        <button
          type="button"
          onClick={refresh}
          className="text-xs text-muted underline hover:text-ink"
        >
          Refresh
        </button>
      </div>
      <WalletDetailView detail={detail} />
    </div>
  );
}
